import React from 'react';

import { black, exactWhite, lightGray } from '../../utils/style/colors';
import APopover from '../APopover';
import { PopoverPlacement } from '../PopoverBase/types';
import IconTypes from './IconTypes';
import { Spinner } from '../Button/style';

export interface IIconProps extends React.HTMLAttributes<HTMLElement> {
  type: IconTypes;
  title?: string | any;
  disabled?: boolean;
  border?: boolean;
  color?: string;
  titleClick?: boolean;
  titlePlacement?: PopoverPlacement;
  loading?: boolean;
}

const Icon: React.FC<IIconProps> = ({
  type,
  className,
  title,
  disabled,
  border,
  color = black,
  style,
  titleClick,
  titlePlacement,
  loading,
  ...restProps
}) => {
  function getStyle() {
    const ret = border
      ? {
          border: !disabled
            ? `3px solid ${color ?? exactWhite}`
            : '3px solid ' + lightGray,
          borderRadius: '50%',
          padding: '10px',
          ...(style || {}),
        }
      : { ...(style || {}) };
    if (color && !disabled) {
      ret['color'] = color;
    }

    return ret;
  }

  const icon = loading ? (
    <i
      style={getStyle()}
      {...restProps}
      onClick={() => {
        {
          /*do nothing*/
        }
      }}
    >
      <Spinner style={{ width: '1.2rem' }} color={color} viewBox="0 0 128 128">
        <path
          className="path"
          d="M75.4 126.6a11.4 11.4 0 0 1-2.1-22.6 40.9 40.9 0 0 0 30.5-30.6 11.4 11.4 0 1 1 22.3 4.9h0a63.8 63.8 0 0 1-47.8 48.1v0a11.4 11.4 0 0 1-2.9z"
        />
      </Spinner>
    </i>
  ) : (
    <i
      className={`icon icon-${type} ${className ? className : ''} ${
        disabled ? 'mygray-text disable-pointer-events' : ''
      }`}
      {...restProps}
      style={getStyle()}
    />
  );
  if (title)
    return (
      <APopover
        arrow
        curveBorder={true}
        target={icon}
        placement={titlePlacement || 'top'}
        trigger={titleClick ? 'click' : 'hover'}
      >
        {typeof title === 'string' ? (
          <div style={{ overflow: 'hidden', whiteSpace: 'wrap' }}>{title}</div>
        ) : (
          title
        )}
      </APopover>
    );
  else return icon;
};

export default React.memo(Icon);
